import { Box, FormControlLabel, Radio, Stack, Typography } from "@mui/material";
import ItemOptionDto from "../../../models/ItemOptionDto";
import { useRestaurantData } from "../../../provider/RestaurantDataContext";
import { currencyFormat } from "../../../utils/Utils";

interface OptionProps {
    option: ItemOptionDto;
    displayOnly?: boolean;
}

export default function Option({ option, displayOnly = false }: OptionProps) {
    const { restaurantData: { currency: { detail } } } = useRestaurantData();
    const showPrice = option.price > 0;
    return (
        <Box>
            {displayOnly && <Stack direction='row' justifyContent='space-between' spacing={5}>
                <Typography>{option.value.value}</Typography>
                {showPrice && <Typography>{currencyFormat(option.price)}{detail}</Typography>}
            </Stack>}
            {!displayOnly && <FormControlLabel value={option.id} control={<Radio />} label={`${option.value.value} ${showPrice ? `${currencyFormat(option.price)}${detail}` : ''}`} />}
        </Box>
    );
}